var React = require('react');

function CheckboxBorderCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"default","cx":"7","cy":"8","r":"6","fill":"none","stroke":"currentColor","strokeWidth":"1","key":0}),React.createElement("g",{"className":"selected","stroke":"none","fill":"currentColor","transform":"translate(0, 1)","key":1},[React.createElement("path",{"d":"M10.38 1.45a.5.5 0 0 1-.52.85A5.5 5.5 0 1 0 12.5 7a.5.5 0 1 1 1 0 6.5 6.5 0 1 1-3.12-5.55z","key":0}),React.createElement("path",{"d":"M13.66 1.63a.5.5 0 0 1 .67.74l-6.65 6a.5.5 0 0 1-.67 0L4.67 6.25a.5.5 0 0 1 .67-.74l2 1.82 6.33-5.7z","key":1})])]);
}

CheckboxBorderCircle.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = CheckboxBorderCircle;

CheckboxBorderCircle.default = CheckboxBorderCircle;
